// global
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// components
import PageFilter from 'app/components/commons/layout/Page/PageFilter';
import Page from 'app/components/commons/layout/Page';
import SearchBox from 'app/components/commons/search/SearchBox';
import ClearButton from 'app/components/commons/button/clearButton/ClearButton';
import AddButton from 'app/components/commons/button/AddButton';
import List from 'app/components/commons/layout/ListOLD';
import EmptyList from 'app/components/commons/emptyList/EmptyList';
import HealthProfessionalModal from 'app/components/modals/health-professional/HealthProfessionalModal.js';
import HealthProfessionalChangeStatus from 'app/components/modals/health-professional/HealthProfessionalChangeStatus.js';
import ProfessionsDropdown from 'app/components/commons/dropdownForm/simpleDropdown/ProfessionDropdown';
// utils
import _ from 'lodash';
// redux
import {
  list,
  perPage,
  search,
  reset
} from 'app/redux/actions/health-professional-list/health-professional-list.action';
import { openSave } from 'app/redux/actions/modal/save-update-modal.action';
// stylesheet

//config
import { COLORS } from 'app/config/colors';
import HealthProfessionalControlButtons from './HealthProfessionalControlButtons';

function HealthProfessional(props) {
  const initialState = {
    title: 'Profissionais de Saúde',
    filter: {
      perPage: 15,
      page: 1,
      search: '',
      professionId: null,
      businessPartner: null
    }
  };

  const [state, setState] = useState(initialState);

  useEffect(() => {
    props.dispatch(list(state.filter));

    return () => props.dispatch(reset());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderEmpty = () => <EmptyList emptyMessage='Nenhum profissional encontrado' />;

  const onSearchChange = value => {
    setState(state => ({
      ...state,
      filter: {
        ...state.filter,
        search: value
      }
    }));
  };

  const callSearch = value => {
    if (value) {
      props.dispatch(
        search({
          ...state.filter,
          page: 1,
          search: value
        })
      );
    }
  };

  const clearFilters = () => {
    setState({ filter: { ...initialState.filter } });
    props.dispatch(list({ ...initialState.filter }));
  };

  const onClickIncreaseListLimit = () => {
    const listParams = state.filter;
    const page = listParams.page + 1;

    setState(state => ({ ...state, filter: { ...listParams, page } }));
    props.dispatch(
      perPage({
        ...listParams,
        perPage: listParams.perPage,
        page
      })
    );
  };

  const onChangeProfessionalFilter = (e, target) => {
    const { value } = target || e.target;

    setState(state => ({
      ...state,
      filter: {
        ...state.filter,
        professionId: value
      }
    }));

    props.dispatch(
      search({
        ...state.filter,
        professionId: value
      })
    );
  };

  const onClickCreate = () => () => props.dispatch(openSave());

  const renderTable = () => {
    return (
      <List
        columns={columns}
        rows={healthProfessionalsList}
        onClickIncreaseList={onClickIncreaseListLimit}
      />
    );
  };
  const statusNode = professional => {
    const isActive = professional.status === 1;
    const statusName = isActive ? 'ATIVO' : 'INATIVO';

    return (
      <div
        style={{
          color: isActive ? COLORS.ALERT_POSITIVE : COLORS.ALERT_NEGATIVE
        }}
      >
        {statusName}
      </div>
    );
  };

  const addressNode = professional => {
    return (
      <div>
        {`${professional.address.address || '--'}${
          professional.address.number ? `, ${professional.address.number}` : ''
        }`}
        {professional.address.state && professional.address.city && (
          <small>
            {professional.address.state}, {professional.address.city}
          </small>
        )}
      </div>
    );
  };

  const onKeyPressCallSearch = (e, term) => {
    if (e.key === 'Enter' && term) {
      callSearch(term);
    }
  };

  const columns = [
    {
      id: 1,
      width: 2,
      textAlign: 'left',
      headerTag: 'cpf',
      property: 'cpf'
    },
    {
      id: 2,
      width: 3,
      textAlign: 'left',
      headerTag: 'nome',
      property: 'name'
    },
    {
      id: 3,
      width: 2,
      textAlign: 'left',
      headerTag: 'profissão',
      property: 'profession.name'
    },
    {
      id: 4,
      width: 2,
      textAlign: 'left',
      headerTag: 'telefone',
      property: 'contact.phone'
    },
    {
      id: 5,
      width: 2,
      textAlign: 'left',
      headerTag: 'endereço',
      bodyNode: addressNode
    },
    { id: 6, width: 2, textAlign: 'center', headerTag: 'status', bodyNode: statusNode },
    {
      id: 7,
      width: 2,
      textAlign: 'center',
      headerTag: '',
      bodyNode: row => <HealthProfessionalControlButtons row={row} />
    }
  ];

  const { healthProfessionalList } = props;

  const { loadedData, loading } = healthProfessionalList;
  const healthProfessionalsList = loadedData;

  return (
    <Page id='page' loading={loading}>
      <Page.BreadCrumb paths={[{ text: 'USUÁRIOS' }, { text: initialState.title }]} />

      <PageFilter>
        <PageFilter.Left>
          <SearchBox
            labelText='Pesquisar'
            placeholder='Pesquisar...'
            popupSearchText='Pesquisar por nome'
            value={state.filter.search}
            onKeyPress={e => onKeyPressCallSearch(e, state.filter.search)}
            onChange={e => onSearchChange(e.target.value)}
            onClick={() => callSearch(state.filter.search)}
          />
          <ProfessionsDropdown
            // label='Profissão'
            placeholder='Selecionar profissão'
            value={state.filter.professionId}
            onChange={onChangeProfessionalFilter}
            searchable
          />
        </PageFilter.Left>
        <PageFilter.Right>
          <ClearButton onClick={clearFilters} />
          <AddButton onClick={onClickCreate()} />
        </PageFilter.Right>
      </PageFilter>

      <Page.Content>
        {_.isEmpty(healthProfessionalList) ? renderEmpty() : renderTable()}
      </Page.Content>

      <HealthProfessionalModal />
      <HealthProfessionalChangeStatus />
    </Page>
  );
}

HealthProfessional.propTypes = {
  healthProfessional: PropTypes.object,
  auth: PropTypes.object,
  dispatch: PropTypes.func,
  healthProfessionalList: PropTypes.object
};

const mapStateToProps = state => ({
  healthProfessional: state.healthProfessional,
  healthProfessionalList: state.healthProfessionalList,
  auth: state.auth
});

export default connect(mapStateToProps)(HealthProfessional);
